import React, { useState } from 'react';
import { Calendar } from './ui/calendar';
import { useLanguage } from '../contexts/LanguageContext';
import { content, blockedDates } from '../mock';

export const AvailabilityCalendar = () => {
  const { language } = useLanguage();
  const t = content[language];
  const [month, setMonth] = useState(new Date());

  // Parse blocked dates from mock data (simulating ICS feed)
  const blocked = blockedDates.map(dateStr => new Date(dateStr));

  const isDateBlocked = (date) => {
    return blocked.some(blockedDate => 
      blockedDate.getDate() === date.getDate() &&
      blockedDate.getMonth() === date.getMonth() &&
      blockedDate.getFullYear() === date.getFullYear()
    );
  };

  return (
    <div className="pb-6 mb-6 border-b">
      <h3 className="text-xl font-semibold mb-4">{t.availabilityTitle}</h3>
      
      <div className="w-full">
        <Calendar
          mode="single"
          month={month}
          onMonthChange={setMonth}
          className="rounded-md w-full"
          modifiers={{
            blocked: blocked
          }}
          modifiersStyles={{
            blocked: {
              textDecoration: 'line-through',
              opacity: 0.4,
              backgroundColor: '#fee2e2',
              color: '#991b1b'
            }
          }}
          disabled={isDateBlocked}
        />
      </div>

      {/* Legend */}
      <div className="mt-4 space-y-2 text-sm">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border border-gray-300 rounded"></div>
          <span className="text-gray-600">{t.availableDates}</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-red-100 border border-red-200 rounded line-through"></div>
          <span className="text-gray-600">{t.bookedDates}</span>
        </div>
      </div>
    </div>
  );
};
